<template>
  <div>
    <div class="row">
      <div class="col-md-4">
        <h3>Permissions</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 card">
        <div class="card-body row">
          <div class="col-2">
            <el-select
              class="select-default"
              v-model="pagination.perPage"
              placeholder="Per page"
              size="mini"
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
          </div>
          <div class="col-sm-12 mt-2">
            <!-- <el-table class="table-striped" :data="tableData" border style="width: 100%">
              <el-table-column
                v-for="column in tableColumns"
                align="center"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
              ></el-table-column>
            </el-table>-->
            <el-table class="table-striped" :data="tableData" border style="width: 100%">
              <el-table-column prop="id" label="ID" min-width="50" align="center"></el-table-column>
              <el-table-column
                prop="description"
                label="Description"
                min-width="100"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="is_global_permission"
                label="Global Permission"
                min-width="50"
                align="center"
              >
                <template slot-scope="scope">
                  <span style="margin-left: 10px" v-if="scope.row.is_global_permission == true">✅</span>
                  <span style="margin-left: 10px" v-else>❌</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="col-sm-6 pagination-info">
            <p class="category">Showing {{from + 1}} to {{to}} of {{total}} entries</p>
          </div>
          <div class="col-sm-6">
            <p-pagination
              class="pull-right"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="pagination.total"
              @input="inputChanged($event)"
            ></p-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import users from "src/components/Dashboard/Views/Tables/users";
import HTTP from "src/util/http-common.js";
import Modal from "src/components/UIComponents/Modal.vue";
import swal from "sweetalert2";
import { Icon } from "element-ui";

export default {
  components: {
    Modal,
    [Icon.name]: Icon
  },
  data() {
    return {
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [2, 5, 10, 25, 50],
        total: 0
      },
      tableColumns: [
        {
          prop: "id",
          label: "Permission ID",
          minWidth: 110
        },
        {
          prop: "description",
          label: "Description",
          minWidth: 150
        },
        {
          prop: "is_global_permission",
          label: "Global Permission",
          minWidth: 150
        }
      ],
      tableData: []
    };
  },
  computed: {
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    }
  },
  watch: {
    "pagination.perPage": function(newVal, oldVal) {
      this.pagination.currentPage = 1;
      this.setPermissions();
      // this.setBookings();
    }
  },
  created() {
    this.setPermissions();
  },
  methods: {
    handleLink(index, row) {
      this.$router.push({ path: `/bookings/${row.id}` });
    },
    inputChanged(pageNum) {
      this.setPermissions();
    },
    async fetchPermissions() {
      let params = {
        permission_level: "all",
        page: this.pagination.currentPage,
        page_size: this.pagination.perPage
      };

      const response = await HTTP.get("api/v1/permission/list", {
        params: params
      });
      const data = await response.data;
      return data;
    },
    setPermissions() {
      this.tableData = [];
      let loader = this.$loading.show();
      this.fetchPermissions()
        .then(data => {
          const results = data.results;
          this.pagination.total = data.total;
          this.tableData = results;
          loader.hide();
        })
        .catch(err => {
          if (err.response) {
            // Request made and server responded
            const error = err.response.data.error;
            const status_code = err.response.status;
            if ("errors" in err.response.data) {
              swal({
                title: "Bad Request",
                text: err.response.data.message,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
              return;
            }
            if (status_code == 500) {
              swal({
                title: "Server Error",
                text: "Internal Server Error. Please try again later..",
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            } else {
              swal({
                title: "Bad Request",
                text: error,
                buttonsStyling: false,
                confirmButtonClass: "btn btn-danger btn-fill",
                type: "error"
              });
            }
          } else if (err.request) {
            // The request was made but no response was received
            swal({
              title: "Server Error",
              text: err.request,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          } else {
            // Something happened in setting up the request that triggered an Error
            swal({
              title: "Error",
              text: err.message,
              buttonsStyling: false,
              confirmButtonClass: "btn btn-danger btn-fill",
              type: "error"
            });
          }
          loader.hide();
        });
    },
    filterGlobalPermissionIcon(value, row) {
      if (row.is_global_permission === true) {
        return "el-icon-circle-check";
      }

      return "el-icon-circle-cross";
    }
  }
};
</script>
<style scoped lang="scss">
.el-table .td-actions {
  button.btn {
    margin-right: 5px;
  }
}
</style>
